export const pageWidth = {
  smaller: 500,
  small: 660,
  medium: 800,
  large: 1220,
}
